import guaranteeShield from "assets/guarantee_shield.svg";
import { useShowComponentByRoutes } from "hooks/useShowComponentByRoutes";
import { INTERNAL_PATHS } from "routes/paths";
import "./index.scss";

const ROUTES_TO_SHOW = [
  INTERNAL_PATHS.BRAND_ALERTS,
  INTERNAL_PATHS.USER_LOG_IN
];

export const GuaranteeBanner = () => {
  const { isVisible } = useShowComponentByRoutes({ routes: ROUTES_TO_SHOW });

  if (!isVisible) return null;

  return (
    <div className="guarantee-container" data-testid="guarantee-banner">
      <img
        src={guaranteeShield}
        className="shield-image"
        alt="guarantee shield"
        importance="low"
        decoding="async"
        loading="lazy"
      />
      <div className="colored-banner">
        <p>90 Day Money-Back Guarantee</p>
      </div>
    </div>
  );
};
